import { Record } from 'immutable';
import { map } from 'lodash';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  recentDealList: null,
  all: null,
  csv: null,
  deal: null,
  dealer: null,
  payments: null,
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

/**
 * After we update a deal we want to merge the updated data
 * to the recent deal list, otherwise it will not get updated
 * until the next tick of polling.
 */
const mergeUpdated = (updated) => (deal) => {
  if (deal.id === updated.id) {
    return { ...deal, ...updated };
  }
  return deal;
};

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.RECENT_DEAL_LIST_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('recentDealList', payload);
    case types.ALL_DEALS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('all', payload);
    case types.DEAL_SUCCESS:
    case types.DEAL_CREATE_SUCCESS:
    case types.ONLINE_DEAL_CREATE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('deal', payload);
    case types.DEALER_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('dealer', payload);
    case types.PAYMENTS_SUCCESS:
      return state.set('payments', action.payload);
    case types.SHOWROOM_LIST_REQUEST:
    case types.RECENT_DEAL_LIST_REQUEST:
    case types.ALL_DEALS_REQUEST:
    case types.DEAL_REQUEST:
    case types.DEAL_CREATE_REQUEST:
    case types.ONLINE_DEAL_CREATE_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.PAYMENTS_REQUEST:
    case types.PAYMENTS_RESET:
      return state.set('payments', null);
    case types.SHOWROOM_LIST_FAILURE:
    case types.RECENT_DEAL_LIST_FAILURE:
    case types.ALL_DEALS_FAILURE:
      return state.set(constants.ERROR_KEY, action.payload);
    case types.DEAL_FAILURE:
    case types.DEALER_FAILURE:
    case types.PAYMENTS_FAILURE:
    case types.DEAL_TRADEINS_UPDATE_FAILURE:
    case types.DEAL_UPDATE_FAILURE:
    case types.ONLINE_DEAL_CREATE_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.SET_DEAL_TRADEINS:
      return state.set('deal', {
        ...state.get('deal'),
        tradeIns: payload.tradeIns,
      });
    case types.DEAL_TRADEINS_UPDATE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false);
    case types.DEAL_UPDATE_SUCCESS: {
      const recentDealList = map(
        state.get('recentDealList'),
        mergeUpdated(payload),
      );
      return state
        .set('recentDealList', recentDealList)
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('deal', payload);
    }
    default:
      return state;
  }
};
